<div class="flex justify-center w-full md:mt-11 pb-8">
    <img src="assets/icons/Icons/other-payment-options/zapper-logo.png" alt="zapper logo">
</div>
<div class="w-full">
    <p class="my-6">Pay conveniently and securely using Zapper&#33; </p>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 1:</b>
        <p class="col-span-3 md:col-span-5">Make sure you have the Zapper app installed on your phone</p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 2:</b>
        <p class="col-span-3 md:col-span-5">Scan the Zapper QR code that is presented on the screen</p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 3:</b>
        <p class="col-span-3 md:col-span-5">Your payment will be processed via the Zapper App </p>
    </div>
</div>